export default __webpack_public_path__ + "static/media/aspiring-writer.5d8f3bc2.jpg";